export default __webpack_public_path__ + "static/superhuman-ai-1-b76a97eea9a05f455698f9c5831ee05d.webp";